export default function (context) {
    context.commit('loading', true);
    axios({
        method: 'GET',
        url: '/tourclient/account/logout?_=' + new Date().getTime(),
        requestId: 'account/logout',
    }).then(d => {
        if (!DEV) {
            window.location.href = '/tourclient/login.html';
            return;
        }
        context.commit('loading', false);
        context.commit('clean');
        context.commit('events/clean');
        context.commit('permit/clean');
        context.commit('setting/clean');
    }).catch(d => {
        context.commit('loading', false);
        context.dispatch('error', {status: d.status}, {root: true});
    });
}